<template>
  <div class="client-item-box" :data-trackdata="tData" v-if="formatData" @click="videoAction">
    <div :class="videowrap" :style="{height: `${formatData.height}px`, overflow:'hidden'}">
      <beast-video
        :wrap="videowrap"
        :height="formatData.videoHeight"
        :poster="formatData.poster"
        :autoplay="formatData.autoplay"
        :source="formatData.source"
        :controls="formatData.controls"
        :videoFormat="formatData.videoFormat"
        :muted="formatData.muted"
        :videoPopData="formatData.videoPopData"
        :multiVideo="multiVideo"
        @video-pop="videoPopAction"
      />
    </div>
    
    <video-pop
      v-if="videoPopFlag"
      :data="videoPopData"
      @close="closeAction"
    />
  </div>
</template>

<script>
import { ensure_protocol } from '@beastshop/url-util'
import { getClientWidth, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getToMiniLink, getLinkPageData } from '@/link'
import { zipImage } from '@/util'

import beastVideo from '@/components/video'
import videoPop from './video-pop.vue'

const clientWidth = getClientWidth()

export default {
  name: 'article-video',
  props: ['data', 'pageType', 'modIndex', 'multiVideo', 'miniEnv', 'isApp'],
  components: {
    beastVideo,
    videoPop
  },
  data () {
    return {
      videoPopFlag: false,
      videoPopData: null,
      formatData: null,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },

  mounted() {
  },

  computed: {
    videowrap () {
      return `wrap${this.modIndex}`
    },

    // formatData () {
    //   let formatData = {}
    //   formatData.poster = this.data.poster && ensure_protocol(this.data.poster.src)
    //   formatData.source = this.data.src && ensure_protocol(this.data.src)
    //   if(this.data.poster && this.data.poster.width) {
    //     let height = (this.data.poster.height/this.data.poster.width)*this.containerWidth()
    //     formatData.height = height
    //   }
    //   const videoMode = this.data.videoMode
    //   formatData['muted'] = (this.data.videoVoice === 'OPEN')?'':'muted',
    //   formatData['videoMode'] = videoMode
    //   formatData['videoFormat'] = this.data.videoFormat
    //   formatData['autoplay'] = (videoMode==='AUTO' || videoMode==='CONTROL')?true:false
    //   formatData['controls'] = videoMode==='AUTO'?false:true

    //   const videoPopData = {
    //     wrapPopIndex: `wrap${this.modIndex}-1`,
    //     height: formatData.height,
    //     poster: formatData.poster,
    //     source: formatData.source,
    //     controls: formatData.controls,
    //     videoFormat: formatData.videoFormat,
    //     muted: formatData.muted
    //     // controls: true
    //   }
    //   formatData.videoPopData = videoPopData

    //   return formatData
    // },

    // classObj () {
    //   let clsObj = null
    //   if(this.pageType === "article" || this.pagetype === "index") {
    //     clsObj = {
    //       'mb15': !this.data.hideBottomGap,
    //       'plr15': !this.data.fullWidth
    //     }
    //   }
    //   if(this.pageType === "shop") {
    //     if(this.data.fullWidth) {
    //       clsObj = {
    //         'pb20': true
    //       }
    //     } else {
    //       clsObj = {
    //         'plr25': true,
    //         'pb20': true
    //       }
    //     }
    //   }

    //   return clsObj
    // }
  },

  created () {
    this.formatVideoData()
  },

  methods: {
    containerWidth () {
      let cw;
      let pageWidth = clientWidth
      const {
        pl,
        pr
      } = this.data.paddingData

      // if(this.data.fullWidth) {
      //   cw = clientWidth
      // } else {
      //   if(this.pageType === "article") {
      //     pageWidth = 375-30
      //   }
      //   if(this.pageType === "shop-story") {
      //     pageWidth = 375-80
      //   }
      //   if(this.pageType === "shop") {
      //     pageWidth = 375-50
      //   }
      //   cw = (pageWidth/375)*clientWidth
      // }
      // if(this.data.fullWidth) {
      //   cw = pageWidth
      // } else {
      //   cw = pageWidth-pl-pr
      // }
      cw = pageWidth-pl-pr
      return cw
    },

    formatVideoData () {
      let formatData = {}
      const poster = zipImage(this.data.poster)
      formatData.poster = poster && ensure_protocol(poster.src)
      formatData.source = this.data.src && ensure_protocol(this.data.src)
      if(this.data.poster && this.data.poster.width) {
        let height = (this.data.poster.height/this.data.poster.width)*this.containerWidth()
        // formatData.height = height
        formatData.height = parseInt(height)
        formatData.videoHeight = parseInt(height)+2
      }
      formatData.link = this.data.link || {type: 'none', value: ''}
      formatData.toMiniProgram = this.data.toMiniProgram || false

      const videoMode = this.data.videoMode
      formatData['muted'] = (this.data.videoVoice === 'OPEN')?'':'muted',
      formatData['videoMode'] = videoMode
      formatData['videoFormat'] = this.data.videoFormat
      // formatData['videoFormat'] = 'COVER'
      formatData['autoplay'] = (videoMode==='AUTO' || videoMode==='CONTROL')?true:false
      formatData['controls'] = videoMode==='AUTO'?false:true

      const videoPopData = {
        wrapPopIndex: `wrap${this.modIndex}-1`,
        height: formatData.height,
        videoHeight: formatData.videoHeight,
        poster: formatData.poster,
        source: formatData.source,
        controls: formatData.controls,
        videoFormat: formatData.videoFormat,
        muted: formatData.muted
        // controls: true
      }
      formatData.videoPopData = videoPopData

      // return formatData
      // this.formatData = formatData
      setTimeout(() => {
        this.formatData = formatData
      }, 200)
    },

    videoPopAction (data) {
      console.log(data, "videoPopAction data")
      trackAction({
        trackData: this.data.trackData
      })

      this.videoPopData = data
      this.videoPopFlag = true
    },

    videoAction () {
      const formatData = this.formatData
      if(this.pageType === 'index') {//首页视频 不支持跳转
        return
      }

      if(this.pageType === 'article' && formatData.videoMode !== 'AUTO') {//专题页视频 非背景自动播放 无法跳转
        return
      }

      const link = formatData.link
      if(!link.type || link.type === 'none') {
        return
      }

      let myLink = ''
      let toMiniFlag = false
      if(this.isApp && formatData.toMiniProgram) {//app环境 且 在app打开小程序页面
        myLink = getToMiniLink({
                link: formatData.link
              })
      }
      if(myLink) {
        toMiniFlag = true
      }
      if(!myLink) {
        myLink = transformLink({
                link: formatData.link,
                isMini: this.miniEnv
              })
      }

      const trackData = this.data.trackData
      trackAction({
        trackData,
        pageObj: getLinkPageData({
          link: formatData.link
        })
      })

      normalSkip({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      })
    },

    closeAction () {
      this.videoPopFlag = false
    },

  }
}
</script>



// WEBPACK FOOTER //
// video.vue?349f72ae